export type PackId = 'single' | 'trio' | 'crew'

const EVENT = 'gritvue:select-offer'

/**
 * Scrolls straight to the pack's own product card, so the visitor lands on
 * the product (image, price, buy button), not the "Choose your loadout"
 * heading. Waits a beat for the selection to render.
 */
export function scrollToPackCta(id: PackId | 'business') {
  if (typeof window === 'undefined') return
  const targetId = id === 'business' ? 'company' : `pack-${id}`
  const attempt = (tries: number) => {
    const target = document.getElementById(targetId)
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' })
      return
    }
    if (tries < 10) window.setTimeout(() => attempt(tries + 1), 60)
  }
  window.setTimeout(() => attempt(0), 60)
}

/**
 * Lets any CTA on the page select the pack it argues for and takes the
 * visitor directly to that pack's buy button.
 */
export function requestOffer(id: PackId) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<PackId>(EVENT, { detail: id }))
  scrollToPackCta(id)
}

const BUSINESS_EVENT = 'gritvue:business-quantity'

/** Sets the Business / Crew Pack quantity when a smaller card switches to it. */
export function requestBusinessQuantity(quantity: number) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<number>(BUSINESS_EVENT, { detail: quantity }))
}

export function onBusinessQuantityRequest(handler: (quantity: number) => void) {
  const listener = (event: Event) => handler((event as CustomEvent<number>).detail)
  window.addEventListener(BUSINESS_EVENT, listener)
  return () => window.removeEventListener(BUSINESS_EVENT, listener)
}

export function onOfferRequest(handler: (id: PackId) => void) {
  const listener = (event: Event) => handler((event as CustomEvent<PackId>).detail)
  window.addEventListener(EVENT, listener)
  return () => window.removeEventListener(EVENT, listener)
}
